<template>
    <ul class="said-list">
        <li class="said-item" v-for="items in refArr" :key="items.id">
            <div class="hd">
            	<div class="date clearfix">
					<div class="date1 l"><span class="y-m">{{getYear(items[0].published_time)}}</span><span class="d">{{getDate(items[0].published_time)}}</span></div>
					<div class="date2 l"><span class="d">{{getDay(items[0].published_time)}}</span><span class="week">{{getWeek(items[0].published_time)}}</span></div>
				</div>
            </div>
            <div class="bd">
                <div class="line"></div>
            	<div class="text-item" v-for="item in items" :key="item.id">
                    <span class="round-icon"></span>
                    <div class="info clearfix"><span class="time l">{{formateTime(item.published_time)}}</span><span class="author r">{{item.post_source}}</span></div>
            		<router-link :to='{name:"detailView",params:{detail_type:"mobile",cid:item.category_id,id:item.id}}' class="box">
            			<h3 class="tit">{{item.post_title}}</h3>
            		</router-link>
            		<div class="text-content">{{item.post_excerpt}}</div>
                    <div class="text-btm">
                      <a href="javascript:;" @click="share(item)" class="shareBtn" data="2018-09-10"><i class="iconfont icon-share"></i>分享</a>
                    </div>
            	</div>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			required: true
		}
	},
    data () {
        return {
        }
    },
    methods: {
    	formateTime (date) {
    		let time = new Date(date * 1000);
    		let fmt = 'hh:mm'
    		if (/(h+)/.test(fmt)) {
    			let hours = time.getHours();
    			hours = hours < 10 ? '0' + hours : hours;
    			fmt = fmt.replace(RegExp.$1,hours);
    		}
    		if (/(m+)/.test(fmt)) {
    			let minutes = time.getMinutes();
    			minutes = minutes < 10 ? '0' + minutes : minutes;
    			fmt = fmt.replace(RegExp.$1,minutes);
    		}
    		return fmt;
    	},
    	getYear (date) {
    		let time = new Date(date * 1000);
    		let year = time.getFullYear();
    		let month = time.getMonth() + 1;
    		month = month < 10 ? '0' + month : month;
    		return year + '.' + month
    	},
    	getDate (date) {
    		let time = new Date(date * 1000);
    		let d = time.getDate();
    		d = d < 10 ? '0' + d : d;
    		return d;
    	},
    	getDay (date) {
    		let time = new Date(date * 1000) / 1000;
    		var start = new Date();
	        start.setHours(0);
	        start.setMinutes(0);
	        start.setSeconds(0);
	        start.setMilliseconds(0);
	        var newTime = Date.parse(start) / 1000;
    		let differTime = newTime - time;
    		let day = differTime / (60 * 60 * 24)
            day = day < 0 ? 0 : parseInt(day) + 1;
    		switch (day) {
    			case 0:
    				day = '今天'
    				break;
    			case 1:
    				day = '昨天'
    				break;
    			case 2:
    				day = '前天'
    				break;
    			default :
    				day = day + '天前'
    		}
    		return day;
    	},
        getWeek (date) {
            let time = new Date(date * 1000);
            let week = time.getDay();
            switch (week) {
                case 0:
                    week = '星期日'
                    break;
                case 1:
                    week = '星期一'
                    break;
                case 2:
                    week = '星期二'
                    break;
                case 3:
                    week = '星期三'
                    break;
                case 4:
                    week = '星期四'
                    break;
                case 5:
                    week = '星期五'
                    break;
                case 6:
                    week = '星期六'
                    break;
            }
            return week;
        },
        share (item) {
            this.$emit('setData',item);
        }
    },
    computed: {
    	refArr () {
    		let newArr = [];
    		this.items.forEach((el, index) => {
    			if (el.is_day_first == 1) {
    				let arr = [];
    				arr.push(el);
    				let s_arr = this.items.slice(index + 1);
    				for (let i = 0; i < s_arr.length; i++) {
    					if (s_arr[i].is_day_first == 0) {
    						arr.push(s_arr[i]);
    					}
    					else {
    						break;
    					}
    				}
    				newArr.push(arr)
    			}
    		});
    		return newArr
    	}
    }
}
</script>
<style lang="scss">
.said-list{
    padding: .2rem 0.3rem;
}
.said-item{
    margin-bottom: .4rem;
    &:last-child{
        margin-bottom: 0;
    }
    .hd{
        margin-bottom: .3rem;
        .date {
            .date1{
                background:url("../common/images/date-icon.png") no-repeat;
                width:70px;
                height: 60px;
                background-size: contain;
                margin-right: .15rem;
                span{
                    display: block;text-align:center;
                }
                .y-m{
                    color: #fff;
                    font-size:12px;
                    line-height: 20px;
                }
                .d{
                    font-size: 20px;
                    line-height: 30px;
                }
            }
            .date2{
                span{
                    display: block;
                }
                .d{
                    font-size:.3rem;
                    font-weight:600;
                    line-height: .5rem;
                    color: #333;
                }
                .week{
                    font-size:.28rem;
                    color: #666;
                }
            }
        }
    }
    .bd{
        padding-left: 22px;position: relative;
        .line{
            position: absolute;
            width:1px;
            background:#e6e6e6;
            left:.1rem;
            height: 100%;
        }
        .text-item{
            padding-bottom: .5rem;
            position: relative;
            .info {
                height: 13px;
                line-height: 13px;
                margin-bottom:.15rem;
                .time{
                    margin-right: .2rem;
                }
            }
            .tit{
                font-size: .3rem;
                font-weight: 600;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                color: #333;
                max-height: .8rem;
                line-height: .4rem;
                margin-bottom: .2rem;
            }
            .text-content{
                line-height: 1.5;
            }
            .round-icon{
                position: absolute;
                width:13px;
                height:13px;
                background:url("../common/images/round-icon.png") no-repeat;
                left:-23px;
                top:0;
            }
            .text-btm{
                margin-top:.2rem;
                text-align:right;
                color: #666;
            }
            .shareBtn .iconfont{
                vertical-align: middle;
                margin-right:.1rem;
                font-size: .35rem;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/said.vue